import { render, staticRenderFns } from "./AutobuyerIntervalButton.vue?vue&type=template&id=46dfd752&scoped=true"
import script from "./AutobuyerIntervalButton.vue?vue&type=script&lang=js"
export * from "./AutobuyerIntervalButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dfd752",
  null
  
)

export default component.exports